type Props = {
  name: string;
  needArrow?: boolean;
  needInfo?: boolean;
  onClickInfo?: () => void;
};

const CityInfoUnitTitle = ({
  name,
  needArrow,
  needInfo,
  onClickInfo: handleClickInfo,
}: Props) => {
  return (
    <h2 className="flex items-center justify-between pb-2 text-2xl">
      <div className="flex items-center ">
        <p className="mr-2">{name}</p>
        {needArrow && (
          <svg
            className="mt-0.5"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5004 0.525391C4.9984 0.525391 0.525391 4.9984 0.525391 10.5004C0.525391 16.0024 4.9984 20.4754 10.5004 20.4754C16.0024 20.4754 20.4754 16.0024 20.4754 10.5004C20.4754 4.9984 16.0024 0.525391 10.5004 0.525391ZM10.5004 18.6064C6.0274 18.6064 2.39439 14.9734 2.39439 10.5004C2.39439 6.0274 6.0274 2.39441 10.5004 2.39441C14.9734 2.39441 18.6074 6.0274 18.6074 10.5004C18.6074 14.9734 14.9734 18.6064 10.5004 18.6064Z"
              fill="#20CEBA"
            />
            <path
              d="M10.081 5.98552C9.72398 5.62852 9.11498 5.62852 8.75798 5.98552C8.40098 6.34252 8.40098 6.95155 8.75798 7.30855L11.95 10.5005L8.75798 13.6925C8.40098 14.0495 8.40098 14.6586 8.75798 15.0156C8.94698 15.2046 9.17798 15.2885 9.42998 15.2885C9.66098 15.2885 9.91298 15.2046 10.102 15.0156L13.945 11.1725C14.113 11.0045 14.218 10.7525 14.218 10.5005C14.218 10.2485 14.113 10.0175 13.945 9.82854L10.081 5.98552Z"
              fill="white"
            />
          </svg>
        )}
      </div>
      {needInfo && (
        <i className="hidden cursor-pointer md:block" onClick={handleClickInfo}>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 0.625C5.95 0.625 0.625 5.95 0.625 12.5C0.625 19.05 5.95 24.375 12.5 24.375C19.05 24.375 24.375 19.05 24.375 12.5C24.375 5.95 19.05 0.625 12.5 0.625ZM12.5 22.151C7.175 22.151 2.85 17.825 2.849 12.5C2.849 7.175 7.175 2.85 12.5 2.849C17.825 2.849 22.15 7.175 22.15 12.5C22.15 17.825 17.825 22.151 12.5 22.151Z"
              fill="white"
              fillOpacity="0.65"
            />
            <path
              d="M14.2448 6.87025C14.2448 8.69625 11.5059 8.69625 11.5059 6.87025C11.5059 5.04325 14.2448 5.04325 14.2448 6.87025Z"
              fill="white"
            />
            <path
              d="M11.9023 10.1074H13.8443V19.5934H11.9023V10.1074Z"
              fill="white"
            />
          </svg>
        </i>
      )}
    </h2>
  );
};

export default CityInfoUnitTitle;
